<button (click)="goBackToHome()" class="back-button" #backButton>
    <h-svg-icon [name]="'back-curved-arrow'" class="icon-back-arrow"></h-svg-icon>
    <span class="back-arrow-txt" i18n="@@hermes_checkout_delivery.back-to-home">Back to home</span>
</button>
